import { Edge, MarkerType } from 'reactflow';

import { LocalPromptDependency } from '../../../../../../services/backendService/types';

type GeneratePromptToPromptOutputEdgesProps = {
  flattedPromptOutputs: LocalPromptDependency[];
};
const generatePromptToPromptOutputEdges = ({
  flattedPromptOutputs,
}: GeneratePromptToPromptOutputEdgesProps) => {
  const edges: Edge[] = [];

  for (const eachPromptOutput of flattedPromptOutputs) {
    const promptSource = eachPromptOutput.id.split('.')[0];
    edges.push({
      id: `${promptSource}-${eachPromptOutput.id}`,
      source: promptSource,
      target: eachPromptOutput.id,
      markerEnd: {
        type: MarkerType.ArrowClosed,
      },
    });
  }
  return edges;
};

export default generatePromptToPromptOutputEdges;
